import { IDIOMAS, NOME_DO_IDIOMA, trocarIdioma } from '../i18n/idioma';
import { useIdioma } from '../i18n/useIdioma';

/** Troca o idioma antes de entrar no mundo — o SettingsModal só existe lá. */
export function SeletorDeIdioma({ className }: { className?: string }) {
  const idioma = useIdioma();
  return (
    <div className={className} role="group" aria-label={NOME_DO_IDIOMA[idioma]}>
      {IDIOMAS.map(id => (
        <button
          key={id}
          type="button"
          className={id === idioma ? 'btn btn--tiny btn--primary' : 'btn btn--tiny'}
          aria-pressed={id === idioma}
          onClick={() => { void trocarIdioma(id); }}
        >
          {NOME_DO_IDIOMA[id]}
        </button>
      ))}
    </div>
  );
}
